import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export default makeStyles<Theme>((theme) =>
  createStyles({
    alert: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  })
);
